import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import LocalStorage from 'local-storage';
import { useEffect, useState } from 'react';
import {
    Stack,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Tooltip,
    Box,
    useMediaQuery
} from '@mui/material';
import { bgBlur } from '../../../utils/cssStyles';
import useResponsive from '../../../hooks/useResponsive';
import { HEADER } from '../../../config-global';
import Iconify from '../../../components/iconify';
import { useAuthContext } from '../../../auth/useAuthContext';
import LoginDeailsService from '../../../services/logindetails.service';
import { PATH_AUTH } from '../../../routes/paths';
import AppCache from '../../../services/appcache';
import usernameService from '../../../services/username.service';

Header.propTypes = {
    onOpenNav: PropTypes.func,
    openNav: PropTypes.bool,
    navWidth: PropTypes.number,
};

export default function Header({ onOpenNav, openNav, navWidth }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const isDesktop = useResponsive('up', 'lg');
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [userData, setUserData] = useState({ companyLogo: '', companyName: '' });
    const IsRedirect = AppCache.GetIsRedirect();

    // is CoontractClaimApprovla Direct Login Check
    const isCCA_DirectLogin = sessionStorage.getItem('CCA_DirectLogin') === 'true';

    const userName = sessionStorage.getItem('userName') || 'Guest';

    useEffect(() => {
        const tokenCheck = LocalStorage.get("_CurrentLoggedInUser")
        if (tokenCheck) {
            LoginDeailsService.CallLoginAPI()
                .then((response) => {
                    if (response.status === 200) {
                        setUserData(response.data);
                    } else {
                         //  console.log("error");
                    }
                })
                .catch(error => {
                     //  console.log("in catch", error);
                });
        }

      
    }, []);


    const handleLogout = async () => {
        try {
            logout();
            sessionStorage.clear();
            localStorage.clear();
            navigate(PATH_AUTH.login, { replace: true });
        } catch (error) {
            console.error(error);
        }
    };

    const hideShow = sessionStorage.getItem('hideShow') === 'true';    

    const renderContent = (
        <>
            {!hideShow && IsRedirect !== '1' && !openNav && (
                <IconButton onClick={onOpenNav} sx={{ mr: 1, color: 'text.primary' }}>
                    <Iconify icon="eva:menu-2-fill" />
                </IconButton>
            )}

            <Stack
                flexGrow={1}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={0}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src="/logo/ProClaimz Logo.jpg"
                        alt="ProClaimz Logo"
                        style={{
                            height: isMobile ? 15 : 25,
                            width: 'auto',
                            objectFit: 'contain',
                            marginRight: theme.spacing(0.5),
                        }}
                    />
                </Box>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexGrow: 1,
                    overflow: 'hidden',
                    marginLeft: theme.spacing(0.5),
                    marginRight: theme.spacing(0.5),
                }}>
                    {userData.companyLogo && (
                        <img
                            src={userData.companyLogo}
                            alt="Company Logo"
                            style={{
                                height: isMobile ? 22 : 40,
                                width: 'auto',
                                objectFit: 'contain',
                            }}
                        />
                    )}
                    <Typography
                        variant='body2'
                        sx={{
                            color: 'gray',
                            fontSize: {
                                xs: '0.6rem',
                                sm: '0.8rem',
                                md: '1.2rem',
                                lg: '1.3rem',
                            },
                            lineHeight: '1em',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {userData.companyName}
                    </Typography>
                </Box>

                <Stack direction="row" spacing={2} alignItems="center">
                    {
                        isCCA_DirectLogin && (
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: { sx: '0.7rem', sm: '0.7rem', md: '0.9rem', lg: '0.9rem' },
                                    color: theme.palette.text.primary,
                                }}
                            >
                                {userName}
                            </Typography>
                        )
                    }

                    <Tooltip title="Logout">
                        <IconButton
                            sx={{
                                width: 40,
                                height: 40,
                                color: IsRedirect === '1' ? '#FFF' : '#B50000',
                                ":hover": {
                                    cursor: IsRedirect === '1' ? "default" : "pointer",
                                    color: IsRedirect === '1' ? '#FFF' : "#FB0000",
                                },
                            }}
                            onClick={(event) => {
                                if (IsRedirect !== '1') {
                                    handleLogout(event); // NOSONAR
                                }
                            }}
                        >
                            <Iconify icon="mdi:shutdown" />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </Stack>
        </>
    );

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default,
                    backgroundColor: theme.palette.background.paper,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(isDesktop && {
                    width: `calc(100% - ${navWidth + 1}px)`,
                    height: HEADER.H_DASHBOARD_DESKTOP,
                    backgroundColor: theme.palette.background.paper,
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { xs: 0.5, sm: 1, lg: 2 },
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}

